<template>
  <span class="box box-solid bg-dark">
    <div class="box-header no-border">
      <h3 class="box-title">Binary Leg</h3>
    </div>
    <div class="box-body bg-dark">
      <div class="d-flex flex-column">
        <button
          @click="swapLeg('left')"
          class="btn pointer-cursor text-white"
          :class="{
            'btn-success ': $store.getters.currentUser.right,
            'btn-dark ': !$store.getters.currentUser.right,
            disabled: !$store.getters.currentUser.right,
          }"
        >
          LEFT
          <i
            v-if="!$store.getters.currentUser.right"
            class="fa fa-check-square"
          ></i>
        </button>

        <button
          @click="swapLeg('right')"
          class="btn pointer-cursor text-white mt-4"
          :class="{
            'btn-success ': !$store.getters.currentUser.right,
            'btn-dark ': $store.getters.currentUser.right,
            disabled: $store.getters.currentUser.right,
          }"
        >
          RIGHT
          <i
            v-if="$store.getters.currentUser.right"
            class="fa fa-check-square"
          ></i>
        </button>
      </div>
    </div>
  </span>
</template>

<script>
import { userMixin } from "@/mixins/";

export default {
  name: "swap-binary-leg",
  mixins: [userMixin],
};
</script>
